/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_CatInputs */

const en_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const ar_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#موبايل`)
};

const bn_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const de_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const es_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const fr_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const pt_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const zh_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const tr_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const ru_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

const pl_svc_mobile_app_development_cat = /** @type {(inputs: Svc_Mobile_App_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOBILE`)
};

/**
* | output |
* | --- |
* | "#MOBILE" |
*
* @param {Svc_Mobile_App_Development_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_cat = /** @type {((inputs?: Svc_Mobile_App_Development_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_cat(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_cat(inputs)
	if (locale === "de") return de_svc_mobile_app_development_cat(inputs)
	if (locale === "es") return es_svc_mobile_app_development_cat(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_cat(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_cat(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_cat(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_cat(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_cat(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_cat(inputs)
	return en_svc_mobile_app_development_cat(inputs)
});
export { svc_mobile_app_development_cat as "svc_mobile-app-development_cat" }